/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Status_Link_ErrorInputs */

const bn_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ট্রাফিক লিঙ্ক ত্রুটি`)
};

const de_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkehrsverbindungsfehler`)
};

const el_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σφάλμα συνδέσμου κυκλοφορίας`)
};

const en_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffic Link Error`)
};

const es_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de enlace de tráfico`)
};

const fr_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur de lien trafic`)
};

const hi_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैफ़िक लिंक त्रुटि`)
};

const hu_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffic Link hiba`)
};

const id_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesalahan Tautan Lalu Lintas`)
};

const it_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore di collegamento del traffico`)
};

const ja_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラフィックリンクエラー`)
};

const ko_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`트래픽 링크 오류`)
};

const nl_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkeerslinkfout`)
};

const pl_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błąd połączenia ruchu`)
};

const pt_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro no link de tráfego`)
};

const ru_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка канала трафика`)
};

const sv_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trafiklänksfel`)
};

const tr_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trafik Bağlantısı Hatası`)
};

const uk_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка трафіку`)
};

const vi_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi liên kết lưu lượng truy cập`)
};

const zh_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流量链接错误`)
};

const zh_hant_cipher_status_link_error = /** @type {(inputs: Cipher_Status_Link_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流量連結錯誤`)
};

/**
* | output |
* | --- |
* | "Traffic Link Error" |
*
* @param {Cipher_Status_Link_ErrorInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_status_link_error = /** @type {((inputs?: Cipher_Status_Link_ErrorInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Status_Link_ErrorInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_status_link_error(inputs)
	if (locale === "de") return de_cipher_status_link_error(inputs)
	if (locale === "el") return el_cipher_status_link_error(inputs)
	if (locale === "en") return en_cipher_status_link_error(inputs)
	if (locale === "es") return es_cipher_status_link_error(inputs)
	if (locale === "fr") return fr_cipher_status_link_error(inputs)
	if (locale === "hi") return hi_cipher_status_link_error(inputs)
	if (locale === "hu") return hu_cipher_status_link_error(inputs)
	if (locale === "id") return id_cipher_status_link_error(inputs)
	if (locale === "it") return it_cipher_status_link_error(inputs)
	if (locale === "ja") return ja_cipher_status_link_error(inputs)
	if (locale === "ko") return ko_cipher_status_link_error(inputs)
	if (locale === "nl") return nl_cipher_status_link_error(inputs)
	if (locale === "pl") return pl_cipher_status_link_error(inputs)
	if (locale === "pt") return pt_cipher_status_link_error(inputs)
	if (locale === "ru") return ru_cipher_status_link_error(inputs)
	if (locale === "sv") return sv_cipher_status_link_error(inputs)
	if (locale === "tr") return tr_cipher_status_link_error(inputs)
	if (locale === "uk") return uk_cipher_status_link_error(inputs)
	if (locale === "vi") return vi_cipher_status_link_error(inputs)
	if (locale === "zh") return zh_cipher_status_link_error(inputs)
	return zh_hant_cipher_status_link_error(inputs)
});